import { createContext, useContext, type ReactNode } from 'react';

import { type ApiClient } from './api-client.js';

const ApiContext = createContext<ApiClient | null>(null);

export function ApiProvider({
  client,
  children,
}: {
  readonly client: ApiClient;
  readonly children: ReactNode;
}): React.JSX.Element {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (client === null) {
    throw new Error('useApi must be used inside an <ApiProvider>');
  }
  return client;
}

export function useOptionalApi(): ApiClient | null {
  return useContext(ApiContext);
}
